<script>
  import { createEventDispatcher } from 'svelte';
  const dispatchPasso = createEventDispatcher();
  import { onMount } from 'svelte';
  import { tenantLogado } from '../../Classes/Stores.js';
  import Conexoes from '../../Classes/Conexoes.js';       
  import Constantes from '../../Classes/Constantes.js';   

  let tenant = $tenantLogado;
  let isLoading = false;
  let mensagem = '';
  let tipoMensagem = 'sucesso'; 

  // Iniciamos vazios e deixamos o onMount preencher com precisão do banco
  let textoPublico = '';
  let corPrimaria = '#4a6c56';
  let logoAtual = null;
  
  let arquivoImagem = null;
  let previewImagem = null;
  let modalPaletaVisivel = false;

  const paletaCores = ['#4a6c56', '#2b6cb0', '#9b2c2c', '#c05621', '#805ad5', '#319795', '#1a202c'];

  function hslToHex(h, s, l) {
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;

    let r = 0;
    let g = 0;
    let b = 0;

    if (h < 60) {
      r = c; g = x; b = 0;
    } else if (h < 120) {
      r = x; g = c; b = 0;
    } else if (h < 180) {
      r = 0; g = c; b = x;
    } else if (h < 240) {
      r = 0; g = x; b = c;
    } else if (h < 300) {
      r = x; g = 0; b = c;
    } else {
      r = c; g = 0; b = x;
    }

    const toHex = value => Math.round((value + m) * 255).toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  function gerarPaleta256() {
    const cores = new Set();

    for (let i = 0; i < 128; i++) {
      const hue = (i * 360) / 128;
      cores.add(hslToHex(hue, 0.85, 0.5));
    }

    for (let i = 0; i < 160; i++) {
      const hue = (i * 360) / 160;
      const saturation = 0.18 + ((i % 4) * 0.06);
      const lightness = 0.8 - ((i % 3) * 0.04);
      cores.add(hslToHex(hue, saturation, lightness));
    }

    for (let i = 0; i < 80; i++) {
      const hue = 20 + (i % 10) * 12;
      const saturation = 0.08 + ((i % 4) * 0.03);
      const lightness = 0.86 - ((i % 5) * 0.03);
      cores.add(hslToHex(hue, saturation, lightness));
    }

    const lista = Array.from(cores);
    return lista.slice(0, 256);
  }

  const paleta256 = gerarPaleta256();

  function abrirPaletaCor() {
    modalPaletaVisivel = true;
  }

  function fecharPaletaCor() {
    modalPaletaVisivel = false;
  }

  function selecionarCor(cor) {
    corPrimaria = cor;
    modalPaletaVisivel = false;
  }

  // BUSCA OS DADOS REAIS DO BANCO ASSIM QUE A TELA ABRE
  onMount(async () => {
    await carregarDadosPersonalizacao();
  });

  async function carregarDadosPersonalizacao() {
    try {
      const conexao = new Conexoes();
      // Envia uma requisição JSON padrão usando a estrutura existente do seu app
      const res = await conexao.conecta(Constantes.api_salvar_personalizacao, {
        id_tenant: tenant.id,
        acao: 'buscar'
      });

      if (res && res.sucesso && res.dados) {
        textoPublico = res.dados.texto_publico || '';
        corPrimaria = res.dados.cor_primaria || '#4a6c56';
        logoAtual = res.dados.logo_url || null;

        // Atualiza a Store interna do Svelte para manter sincronizado com o resto do painel
        let tenantAtualizado = { ...tenant, ...res.dados };
        tenantLogado.set(tenantAtualizado);
        localStorage.setItem('usuarioLogado', JSON.stringify(tenantAtualizado));
      }
    } catch (error) {
      console.error("Erro ao carregar dados de identidade visual:", error);
    }
  }

  function handleFileSelect(event) {
    const file = event.target.files[0];
    if (file) {
      arquivoImagem = file;
      previewImagem = URL.createObjectURL(file);
    }
  }

  async function salvarPersonalizacao(e) {
    e.preventDefault();
    isLoading = true;
    mensagem = '';

    try {
      const formData = new FormData();
      formData.append('id_tenant', tenant.id);
      formData.append('texto_publico', textoPublico);
      formData.append('cor_primaria', corPrimaria);
      
      if (arquivoImagem) {
        formData.append('logo', arquivoImagem);
      }

      const conexao = new Conexoes();
      const res = await conexao.conecta(Constantes.api_salvar_personalizacao, {
        body: formData,
        isFormData: true 
      });

      if (res && res.sucesso) {
        tipoMensagem = 'sucesso';
        mensagem = 'Página pública atualizada com sucesso!';
        
        // Limpa os arquivos temporários de preview
        arquivoImagem = null;
        previewImagem = null;
        
        // Recarrega os dados para forçar a atualização correta da Store e dos campos
        await carregarDadosPersonalizacao();
        // Sugere o próximo passo do checklist
        dispatchPasso('passoConcluido', 'Página personalizada!');
      } else {
        tipoMensagem = 'erro';
        mensagem = res?.mensagem || 'Erro ao salvar configurações.';
      }
    } catch (error) {
      tipoMensagem = 'erro';
      mensagem = 'Falha na conexão com o servidor.';
    } finally {
      isLoading = false;
    }
  }
</script>

<div class="aba-personalizar fade-in">
  <div class="header-section">
    <h2>Personalizar Minha Página</h2>
    <p>Deixe a página de agendamentos com a identidade da sua marca.</p>
  </div>

  {#if mensagem}
    <div class="alert class-{tipoMensagem}">
      <i class="fas {tipoMensagem === 'sucesso' ? 'fa-check-circle' : 'fa-exclamation-triangle'}"></i> {mensagem}
    </div>
  {/if}

  <form on:submit={salvarPersonalizacao} class="form-card">
    
    <div class="form-group mb-5">
      <label>Sua Foto de Perfil ou Logomarca</label>
      <div class="upload-area">
        <div class="avatar-preview" style="border-color: {corPrimaria};">
          {#if previewImagem}
            <img src={previewImagem} alt="Preview" />
          {:else if logoAtual}
            <img src={logoAtual} alt="Sua Logo" />
          {:else}
            <i class="fas fa-camera"></i>
          {/if}
        </div>
        <div class="upload-controls">
          <p class="text-muted">A imagem será exibida no topo do seu link público.</p>
          <input type="file" id="uploadLogo" accept="image/png, image/jpeg, image/webp" on:change={handleFileSelect} hidden />
          <label for="uploadLogo" class="btn-outline">
            <i class="fas fa-upload"></i> Escolher Nova Imagem
          </label>
        </div>
      </div>
    </div>

    <div class="form-group mb-4">
      <label for="bioText">Texto de Apresentação</label>
      <p class="text-muted small">Escreva uma breve mensagem de boas-vindas ou instruções para seus clientes.</p>
      <textarea id="bioText" class="input-modern textarea" bind:value={textoPublico} placeholder="Ex: Olá! Selecione abaixo o melhor horário para o nosso atendimento..."></textarea>
    </div>

    <div class="form-group mb-5">
      <label>Cor Principal da Página</label>
      <p class="text-muted small">Use o seletor nativo para uma cor exata ou abra a roda de cores para escolher uma cor personalizada.</p>
      
      <div class="color-picker-group">
        <input type="color" bind:value={corPrimaria} class="color-input" title="Escolha uma cor personalizada">
        <button type="button" class="icon-picker-btn" on:click={abrirPaletaCor} title="Abrir roda de cores" aria-label="Abrir roda de cores">
          <i class="fas fa-palette"></i>
        </button>
        <div class="swatches">
          {#each paletaCores as cor}
            <button 
              type="button" 
              class="color-swatch {corPrimaria === cor ? 'ativo' : ''}" 
              style="background-color: {cor};" 
              on:click={() => corPrimaria = cor}>
            </button>
          {/each}
        </div>
      </div>
    </div>

    <hr>

    <button type="submit" class="btn-primary" disabled={isLoading} style="background-color: {corPrimaria}; border-color: {corPrimaria};">
      {#if isLoading}
        <i class="fas fa-spinner fa-spin"></i> Salvando...
      {:else}
        <i class="fas fa-save"></i> Salvar Identidade Visual
      {/if}
    </button>
  </form>
</div>

{#if modalPaletaVisivel}
  <div class="modal-overlay fade-in" on:mousedown={fecharPaletaCor}>
    <div class="modal-card color-modal-card" on:mousedown|stopPropagation>
      <button class="close-btn" on:click={fecharPaletaCor} aria-label="Fechar modal de cores">
        <i class="fas fa-times"></i>
      </button>
      <div class="color-modal-header">
        <div>
          <h3>Roda de cores</h3>
          <p>Escolha a cor que representará sua identidade visual.</p>
        </div>
        <div class="current-color-pill" style="background-color: {corPrimaria};">
          <span>{corPrimaria}</span>
        </div>
      </div>

      <div class="palette-grid">
        {#each paleta256 as cor}
          <button
            type="button"
            class="palette-tile {corPrimaria === cor ? 'ativo' : ''}"
            style="background-color: {cor};"
            on:click={() => selecionarCor(cor)}
            title={cor}
            aria-label={`Selecionar cor ${cor}`}
          ></button>
        {/each}
      </div>

      <div class="modal-actions-row">
        <button type="button" class="btn-outline" on:click={fecharPaletaCor}>Cancelar</button>
        <button type="button" class="btn-primary" style="background-color: {corPrimaria}; border-color: {corPrimaria};" on:click={fecharPaletaCor}>
          Aplicar cor
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  /* Mantido exatamente o mesmo CSS do seu arquivo original */
  .aba-personalizar { max-width: 800px; }
  .header-section { margin-bottom: 30px; }
  .header-section h2 { color: var(--text-main); font-weight: 800; font-family: 'Montserrat', sans-serif; margin-bottom: 5px; }
  .header-section p { color: var(--text-muted); }
  .form-card { background: white; padding: 40px; border-radius: 16px; box-shadow: 0 4px 15px rgba(0,0,0,0.03); border: 1px solid var(--border); }
  .form-group { display: flex; flex-direction: column; }
  .form-group label { font-weight: 700; color: var(--text-main); margin-bottom: 5px; }
  .mb-4 { margin-bottom: 20px; }
  .mb-5 { margin-bottom: 35px; }
  .small { font-size: 0.85rem; margin-bottom: 10px; }
  .input-modern { width: 100%; padding: 12px 15px; border: 1px solid var(--border); border-radius: 8px; font-family: inherit; transition: 0.3s; }
  .input-modern:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px rgba(207, 170, 108, 0.2); }
  .textarea { min-height: 120px; resize: vertical; }
  .upload-area { display: flex; align-items: center; gap: 20px; margin-top: 10px; }
  .avatar-preview { width: 100px; height: 100px; border-radius: 50%; border: 3px solid; background: #f0f0f0; display: flex; align-items: center; justify-content: center; overflow: hidden; color: #aaa; font-size: 2rem; }
  .avatar-preview img { width: 100%; height: 100%; object-fit: cover; }
  .btn-outline { display: inline-block; background: transparent; border: 1px solid var(--text-muted); padding: 8px 15px; border-radius: 8px; cursor: pointer; font-weight: 600; color: var(--text-main); transition: 0.2s; }
  .btn-outline:hover { background: #f4f7f5; }
  .color-picker-group { display: flex; align-items: center; gap: 12px; margin-top: 10px; flex-wrap: wrap; }
  .color-input { width: 50px; height: 50px; padding: 0; border: none; border-radius: 8px; cursor: pointer; overflow: hidden; }
  .color-input::-webkit-color-swatch-wrapper { padding: 0; }
  .color-input::-webkit-color-swatch { border: none; border-radius: 8px; }
  .icon-picker-btn {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    border: 1px solid var(--border);
    background: white;
    color: var(--text-main);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  }
  .icon-picker-btn:hover {
    transform: translateY(-1px);
    border-color: var(--accent);
    box-shadow: 0 8px 18px rgba(207, 170, 108, 0.18);
  }
  .swatches { display: flex; gap: 10px; }
  .color-swatch { width: 35px; height: 35px; border-radius: 50%; border: 2px solid transparent; cursor: pointer; transition: transform 0.2s; }
  .color-swatch:hover { transform: scale(1.1); }
  .color-swatch.ativo { border: 3px solid #fff; outline: 2px solid var(--text-main); }

  .modal-overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.55); backdrop-filter: blur(4px); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .modal-card {
    background: white;
    padding: 30px;
    border-radius: 16px;
    position: relative;
    box-shadow: 0 10px 40px rgba(0,0,0,0.2);
  }
  .color-modal-card {
    width: min(100%, 840px);
    max-height: 90vh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
  .close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 1.2rem;
    color: #999;
    cursor: pointer;
  }
  .color-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 14px;
  }
  .color-modal-header h3 {
    margin: 0 0 4px;
    font-size: 1.15rem;
    color: var(--text-main);
  }
  .color-modal-header p {
    margin: 0;
    color: var(--text-muted);
    font-size: 0.92rem;
  }
  .current-color-pill {
    min-width: 132px;
    padding: 12px 14px;
    border-radius: 14px;
    color: white;
    font-weight: 800;
    text-align: center;
    box-shadow: inset 0 0 0 1px rgba(255,255,255,0.35);
    text-shadow: 0 1px 2px rgba(0,0,0,0.22);
  }
  .current-color-pill span {
    display: block;
    font-size: 0.85rem;
    letter-spacing: 0.04em;
  }
  .palette-grid {
    display: grid;
    grid-template-columns: repeat(16, minmax(0, 1fr));
    gap: 4px;
    padding: 12px;
    border-radius: 16px;
    background: linear-gradient(180deg, #f8faf9 0%, #eef3ef 100%);
    border: 1px solid var(--border);
  }
  .palette-tile {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
  }
  .palette-tile:hover { transform: scale(1.08); box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12); }
  .palette-tile.ativo { border: 2px solid #fff; outline: 2px solid var(--text-main); box-shadow: 0 0 0 2px rgba(44, 62, 52, 0.2); }

  .modal-actions-row {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
  .btn-primary { color: white; border: 1px solid; padding: 14px 25px; border-radius: 8px; font-weight: 700; cursor: pointer; font-size: 1.05rem; transition: 0.3s; }
  .btn-primary:hover { opacity: 0.9; transform: translateY(-2px); }
  hr { border: none; border-top: 1px solid var(--border); margin: 30px 0; }
  .alert { padding: 15px; border-radius: 8px; margin-bottom: 20px; font-weight: 600; }
  .class-sucesso { background: #eef5f0; color: #4a6c56; border: 1px solid #cce0d2; }
  .class-erro { background: #fed7d7; color: #c53030; border: 1px solid #feb2b2; }
  .fade-in { animation: fadeIn 0.4s ease-in-out; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

  @media (max-width: 640px) {
    .form-card { padding: 24px 16px; }
    .upload-area { flex-direction: column; align-items: flex-start; gap: 12px; }
    .color-picker-group { flex-direction: column; align-items: flex-start; gap: 12px; }
    .swatches { flex-wrap: wrap; }
    .palette-grid { grid-template-columns: repeat(8, minmax(0, 1fr)); gap: 3px; }
    .color-modal-card { padding: 20px 16px; }
    .color-modal-header { flex-direction: column; align-items: flex-start; }
    .current-color-pill { width: 100%; min-width: 0; }
    .modal-actions-row { flex-direction: column-reverse; }
    .btn-primary, .btn-outline { width: 100%; }
  }
</style>